import { create } from 'zustand';

/**
 * The current page's own name for the top bar's breadcrumb — a job's quote
 * name, say — which only the page knows once its data has loaded. Pages set it
 * and clear it on the way out; the layout reads it.
 */
interface PageTitleState {
	title: string | null;
	setTitle: (title: string | null) => void;
}

export const usePageTitle = create<PageTitleState>()((set) => ({
	title: null,
	setTitle: (title) => set({ title }),
}));
